import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail } from "lucide-react";

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-secondary text-white/90 mt-auto" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid gap-8 md:grid-cols-3 items-start">
          <div className="space-y-3">
            <img
              src="/revivedu-logo.png"
              alt="Revivedu"
              className="h-12 w-auto object-contain brightness-0 invert"
            />
            <p className="text-sm text-white/70 max-w-xs">
              Revivedu - Reviving the joy of learning | revivedu.com
            </p>
            <p className="text-sm text-white/60 max-w-xs" data-testid="footer-positioning-line">
              Personalized learning for homeschooled and gifted children in India.
            </p>
          </div>

          <div className="space-y-3">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-accent">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/70 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link" className="text-white/70 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a href="mailto:hi@revivedu.com" data-testid="footer-email-link" className="text-white/70 hover:text-white transition-colors inline-flex items-center gap-2">
                  <Mail className="h-4 w-4" /> hi@revivedu.com
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-3">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-accent">Follow us</h3>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/letsrevivedu" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="w-10 h-10 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.facebook.com/people/Revivedu/61590708938409/" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="w-10 h-10 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/company/revivedu" target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin-link" className="w-10 h-10 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://x.com/letsrevivedu" target="_blank" rel="noreferrer" aria-label="X" data-testid="footer-x-link" className="w-10 h-10 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                <XIcon />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center text-xs text-white/50">
          &copy; {new Date().getFullYear()} Revivedu. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
